import React from 'react';

// eslint-disable-next-line react/display-name
export default class extends React.Component<Record<string, never>, Record<string, never>> {
    render() {
        return (
            <main>
                <h3>Error</h3>
                <p>Page not found</p>
            </main>
        );
    }
}
